import { render, staticRenderFns } from "./MandalaEvaluationsRadarChart.vue?vue&type=template&id=6c01d3b3"
import script from "./MandalaEvaluationsRadarChart.vue?vue&type=script&lang=js"
export * from "./MandalaEvaluationsRadarChart.vue?vue&type=script&lang=js"
import style0 from "./MandalaEvaluationsRadarChart.vue?vue&type=style&index=0&id=6c01d3b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_359e2a22b61d78988ed9bf0e7b495bd0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports